import React from 'react';

import { P } from '../P/P';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';

export const LE2 = () => (
  <Section>

    <P gapAfter>
      In dieser Lerneinheit setzen sich SuS mit Einflüssen auf ihre Kaufentscheidung auseinander.
      Diese haben viel mit Vertrauen zu tun. Eltern sind oft eine wichtige Finanzquelle,
      aber mit zunehmendem Alter treffen die Jugendlichen ihre Stilentscheidungen lieber mit Freundinnen und Freunden
      oder richten sich nach ihren Vorbildern: Schließlich wollen Jugendliche im eigenen Freundeskreis bzw. in ihrer Bezugsgruppe ankommen.
    </P>
    <P gapAfter>
      Mit der intensiven Nutzung sozialer Netzwerke haben Influencer an Einfluss auf die Kaufentscheidungen von Jugendlichen gewonnen.
      Influencer sind Personen, &#8222;die aufgrund ihrer starken Präsenz und ihres hohen Ansehens in einem oder mehreren sozialen Netzwerken als Träger für Werbung und Vermarktung in Frage kommen” (Wikipedia). Allerdings treten die Grauzonen zwischen Kunden und Vermarktern, Bewertung und Werbung immer deutlicher zutage.
    </P>

    <UL>
      <LI>
        <P><b>Orientierungshilfen</b> abfragen:</P>
        <P>
          Fragen Sie Ihre SuS, wer oder welche Quelle ihnen bei der Kaufentscheidung behilflich ist.
        </P>
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE2.js